// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"35bd453f","404":"c9d130fd"}[chunkId] + ".chunk.js";
};